<head>
  <style>
  .mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline {
      background-position: 0;
      background-color: darkolivegreen;
  }
  </style>
  </head>


  <body style="background: #f0fdff; overflow:auto;">

    <div class="titleBox"> <h1 style="text-align: center">Billing</h1></div>

    <!--
    <div class="loadingOverlay" [hidden]="loading$ | async" >

      <div style="position: absolute;
      /* padding-top: 25%; */
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);">
        <p class="loadingText">Loading Jobs...</p>

        <mat-spinner style="margin: auto; color:white !important;"></mat-spinner>
      </div>

    </div>
    -->

    <hr>
    <div class="billing-list" style="text-align: center;">
        <h3>Search All</h3>
        <input [(ngModel)] = "term">

    </div>
    <div>
      <div style="margin: 20px;
      display: flex;
      background-color: #f0fdff;
      justify-content: space-evenly;
      align-items: center;
      flex-wrap: nowrap;
      background-color: #f0fdff;">

        <h5 style="display: inline;" >From: </h5>
          <input style="color: black;"  [(ngModel)] = "fromDate" matInput color="grey" [matDatepicker]="schedateFrom">
          <mat-datepicker-toggle  touchUi= true matSuffix [for]="schedateFrom"></mat-datepicker-toggle>
          <mat-datepicker #schedateFrom></mat-datepicker>
        <h5 style="display: inline;">To: </h5>
          <input style="color: black;" [(ngModel)] = "toDate" matInput color="grey" [matDatepicker]="schedateTo">
          <mat-datepicker-toggle  touchUi= true matSuffix [for]="schedateTo"></mat-datepicker-toggle>
          <mat-datepicker #schedateTo></mat-datepicker>
         <!-- <input id="importedCSV" type="file" style="display:none" (change)="parseCSV($event)"> -->

      </div>
      <div style="display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;">
        <button mat-button (click)="filterJobs(fromDate, toDate)" style="background-color:  rgb(178, 218, 156);">Filter Dates</button>

        <input type="file" class="file-input-hdn"
         (change)="parseCSV($event)" #fileUpload>

        <button mat-button (click)="fileUpload.click()" style="padding-left: 20px; background-color:  rgb(209, 216, 205);">Import CSV</button>

          <span class="file-upload" style="border-style: dotted; border-width: 1px; border-color: lightgray; width: max-content;">

             {{updaterFilename || "Click (Import CSV) to select a file."}}


          </span>
      </div>


      <!--
      <div style="display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;">

        <p class="row" style="font-size:24px;">Invoice Check</p>      <mat-checkbox style="position: relative;
        bottom: 5px;" class="row" [(ngModel)] = "job.invoicecheck"></mat-checkbox>

        <p class="row" style="font-size:24px;">Invoice Check</p>      <mat-checkbox style="position: relative;
        bottom: 5px;" class="row" [(ngModel)] = "job.invoicecheck"></mat-checkbox>

      </div>
-->


    </div>

    <hr>

    <div class="billing-list" style="    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    background: #f0fdff;">

   <!--<div *ngFor="let job of job$ | async | filter: term; index as i" [class]="cardClass(i)" style="width:80vw;"> -->

<div *ngFor="let job of allJobs | filter: term; let i = index" style="width: calc(100vw - 25%);">

   <div class="container-lite" style="
    background: white;
    border-radius: 50px;
    font-family: 'Roboto';
    filter: drop-shadow(2px 4px 6px lightgrey);
    margin-bottom: 20px;"
    *ngIf="i + 1 ===  allJobs.length" #lastJob
   >
        <div style="margin-top: 50px;"  >
          <div>

              <h3>{{job.customer_name}} - {{job.job_type}}</h3>
              <h4 class="row_noborderTwo">{{job.street_address}}</h4>
              <h4 class="row_noborderTwo"> [{{job.subdivision_name}}-{{job.lot}}] ({{job.region || '(No region specified)'}})</h4>
              <div><h5 class="row_noborderTwo">Job Date - {{job.schedule_date.toString().substring(0,10)}} <span [class]='statusClass(i, job.job_status)'>{{job.job_status}}</span></h5></div>
              <div *ngIf="job.billing_notes || job.billing_note" ><h5 style="font-size: 17px;
                font-weight: 500;
                width: 90%;
                margin: 5%;
                border: 1px solid;
                box-shadow: 2px 5px;" class="row"> Billing Notes: {{job.billing_notes}}  {{job.billing_note}}</h5></div>

              <div><h5>Job Notes: </h5><textarea [rows]="job.job_notes ? 5 : 2" [style.width]="job.job_notes ? '400px' : '300px' " matInput [(ngModel)] = "job.job_notes"></textarea></div>
          </div>
        </div>
        <div>
          <div>
              <div style="display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-evenly;">

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Flat Adder</p><p style="padding-right: 10px;font-size: 24px;" placeholder="Po Number: " >{{job.flatadder}}</p></div>

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Rate</p><p class="row_disabled" style="padding-right: 10px;font-size: 24px;" placeholder="Rate: ">{{job.rate}}</p></div>

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Price</p><p class="row_disabled" style="padding-right: 10px;font-size: 24px;" placeholder="Price: ">{{job.price}}</p></div>

              </div>
          </div>

          <div>
            <div style="    display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-evenly;
            align-content: center;">

              <div><p class="row" style="font-size: 24px;
                margin-bottom: -20px;">Po #</p><input type="text" class="row" style="padding-right: 10px;" placeholder="Po Number: " matInput [(ngModel)]="job.po_number"></div>

              <div><p class="row" style="font-size: 24px;
                margin-bottom: -20px;" >Invoice</p><input type="text" class="row" style="padding-right: 10px;" placeholder="Rate: "matInput [(ngModel)]="job.invoice_number"></div>

              <div style="display: flex;
              width: 40%;
              flex-wrap: nowrap;
              justify-content: space-evenly;
              position: relative;
              top: 20px;">
                <p class="row" style="font-size:24px;">Invoice Check</p>      <mat-checkbox style="position: relative;
                bottom: 5px;" class="row" [(ngModel)] = "job.invoicecheck"></mat-checkbox>

                <p class="row" style="font-size:24px;">EPO Requested</p>      <mat-checkbox style="position: relative;
                bottom: 5px;" class="row" [(ngModel)] = "job.eporeqstd"></mat-checkbox>
              </div>

            </div>
        </div>
        <button mat-button style="margin-bottom: 50px;
        background-color: rgb(255 255 255);
        border: 1px solid;
        border-color: #dbdada;
        margin-right: 8px;" (click)="getPlanInfo(job)">Plan data</button>
        <button mat-button style="margin-bottom: 50px;background-color:  rgb(178, 218, 156);" (click)="saveEntry(job)">Save Changes</button>
        <!--<mat-divider [inset]="i%2 == 1 ? true : false"></mat-divider> -->
        </div>

    </div>

    <div class="container-lite" style="
      background: white;
      border-radius: 50px;
      font-family: 'Roboto';
      filter: drop-shadow(2px 4px 6px lightgrey);
      margin-bottom: 20px;"
      *ngIf="i + 1 != allJobs.length"
   >
        <div style="margin-top: 50px;"  >
          <div>

              <h3>{{job.customer_name}} - {{job.job_type}}</h3>
              <h4 class="row_noborderTwo">{{job.street_address}}</h4>
              <h4 class="row_noborderTwo"> [{{job.subdivision_name}}-{{job.lot}}] ({{job.region || '(No region specified)'}})</h4>
              <div><h5 class="row_noborderTwo">Job Date - {{job.schedule_date.toString().substring(0,10)}} <span [class]='statusClass(i, job.job_status)'>{{job.job_status}}</span></h5></div>
              <div *ngIf="job.billing_notes || job.billing_note" ><h5 style="font-size: 17px;
                font-weight: 500;
                width: 90%;
                margin: 5%;
                border: 1px solid;
                box-shadow: 2px 5px;" class="row"> Billing Notes: {{job.billing_notes}}  {{job.billing_note}}</h5></div>

              <div><h5>Job Notes: </h5><textarea [rows]="job.job_notes ? 5 : 2" [style.width]="job.job_notes ? '400px' : '300px' " matInput [(ngModel)] = "job.job_notes"></textarea></div>
          </div>
        </div>
        <div>
          <div>
              <div style="display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: space-evenly;">

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Flat Adder</p><p style="padding-right: 10px;font-size: 24px;" placeholder="Po Number: " >{{job.flatadder}}</p></div>

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Rate</p><p class="row_disabled" style="padding-right: 10px;font-size: 24px;" placeholder="Rate: ">{{job.rate}}</p></div>

                <div><p class="row" style="font-size: 24px;
                  margin-bottom: -5px;">Price</p><p class="row_disabled" style="padding-right: 10px;font-size: 24px;" placeholder="Price: ">{{job.price}}</p></div>

              </div>
          </div>

          <div>
            <div style="    display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-evenly;
            align-content: center;">

              <div><p class="row" style="font-size: 24px;
                margin-bottom: -20px;">Po #</p><input type="text" class="row" style="padding-right: 10px;" placeholder="Po Number: " matInput [(ngModel)]="job.po_number"></div>

              <div><p class="row" style="font-size: 24px;
                margin-bottom: -20px;" >Invoice</p><input type="text" class="row" style="padding-right: 10px;" placeholder="Rate: "matInput [(ngModel)]="job.invoice_number"></div>

              <div style="display: flex;
              width: 40%;
              flex-wrap: nowrap;
              justify-content: space-evenly;
              position: relative;
              top: 20px;">
                <p class="row" style="font-size:24px;">Invoice Check</p>      <mat-checkbox style="position: relative;
                bottom: 5px;" class="row" [(ngModel)] = "job.invoicecheck"></mat-checkbox>

                <p class="row" style="font-size:24px;">EPO Requested</p>      <mat-checkbox style="position: relative;
                bottom: 5px;" class="row" [(ngModel)] = "job.eporeqstd"></mat-checkbox>
              </div>

            </div>
        </div>
        <button mat-button style="margin-bottom: 50px;
        background-color: rgb(255 255 255);
        border: 1px solid;
        border-color: #dbdada;
        margin-right: 8px;" (click)="getPlanInfo(job)">Plan data</button>
        <button mat-button style="margin-bottom: 50px;background-color:  rgb(178, 218, 156);" (click)="saveEntry(job)">Save Changes</button>
        <!--<mat-divider [inset]="i%2 == 1 ? true : false"></mat-divider> -->
        </div>

    </div>
  </div>

  <p style="text-align: center;
    font-size: 24px; ;" *ngIf = 'loadingScroll == true && isLast == false '>Loading more...</p>


    <p style="text-align: center;
    font-size: 24px; ;" *ngIf = 'loadingScroll == true && isLast == true'> End of Job List  </p>

    <!--
    <ng-template #loading *ngIf="loading">
      <div style= "width: 100%; text-align: center">
        <div style="display: inline-block; margin: auto; padding: 3px">
            <div class="lds-ripple"><div></div><div></div>Loading...</div>
        </div>
      </div>
    </ng-template>
    -->

  </div>

  </body>
